export type TTheLeaderboardSourceKeys =
  | "gamdom"
  | "hypedrop"
  | "packdraw"
  | "wrewards"
  | "clash"
  | "cases"
  | "rain"
  | "luxdrop"
  | "lootbox"
  | "datdrop";

export const TheLeaderboardSourceKeys = {
  gamdom: "GAMDOM",
  hypedrop: "HYPEDROP",
  packdraw: "PACKDRAW",
  wrewards: "WREWARDS",
  clash: "CLASH",
  cases: "CASES",
  rain: "RAIN",
  luxdrop: "LUXDROP",
  lootbox: "LOOTBOX",
  datdrop: "DATDROP",
};
